import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export interface Counted<T> {
    data: T
    count: number
}

export class Count<V = any, E = any, C = any> extends Pass<V, E, C, Counted<V>> {
    protected i = 0

    value(value: V) {
        this._value({
            data: value,
            count: ++this.i,
        })
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        count(): Stream<DV, DE, DC, Counted<DV>, DE, DC>
    }
}

Stream.prototype.count = function <V, E, C>(this: AnySourceStream<V, E, C>) {
    return new Count(this) // tslint:disable-line:no-invalid-this
}
